import Loading from '../../../shared/Loading';
import React from 'react';

const classNames = 'outline outline-1 p-2 text-grey-700 rounded-md';

/**
 * @param {{code: string; isGettingData?: boolean}} props
 * @returns {JSX.Element}
 */
function EmbedCode(props) {
	if (props.isGettingData) {
		return (
			<div className={classNames}>
				<Loading className="p-6 -scale-75" />
			</div>
		);
	}

	return <code className={classNames}>{props.code}</code>;
}

export default React.memo(EmbedCode);
